module.exports = __webpack_public_path__ + "static/media/background.35742a51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/BodyView/background.jpg
// module id = 955
// module chunks = 0